<template>
  <div class="file-upload">
    <ol class="file-upload__list">
      <li
        v-for="file in files"
        :key="file.id"
        class="file-upload__item"
      >
        <span class="file-upload__name">{{file.name}}</span>

        <button
          class="file-upload__delete"
          type="button"
          @click.prevent="remove(file)"
        >
          <img
            src="/static/assets/images/icon-trash.svg"
            alt="delete"
          />
        </button>
      </li>
    </ol>

    <div class="file-upload__control">
      <file-upload
        :ref="refName"
        v-model="files"
        class="file-upload__add button"
        :multiple="multiple"
        :accept="acceptedMimeTypes"
      >+ {{ $t('add_file') }}</file-upload>
    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component';

export default {
  components: {
    FileUpload,
  },
  props: {
    refName: {
      type: String,
      default: 'upload',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      files: [],
    };
  },
  computed: {
    acceptedMimeTypes() {
      return this.accept.length === 0 ? undefined : this.accept.join(',');
    },
  },
  watch: {
    files: 'emitChange',
  },
  methods: {
    remove(file) {
      this.$refs[this.refName].remove(file);
    },
    clear() {
      this.$refs[this.refName].clear();
    },
    emitChange() {
      const files = this.files.map((item) => item.file);
      this.$emit('updateFiles', files);
    },
  },
};
</script>

<style lang="scss">
@import '../../sass/variables';

.file-upload {
  width: 100%;

  &__list {
    padding: 0 0 0 15px;
    margin: 0;
  }

  &__item {
    text-align: left;
  }

  &__name {
    display: inline-block;
    line-height: 20px;
    padding-right: 10px;
    color: $black-j;
  }

  &__delete {
    position: relative;
    top: 3px;
    outline: none;
    background-color: transparent;
    width: 20px;
    height: 20px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: none;
    padding: 0;
  }

  &__control {
    text-align: left;
    margin-top: 10px;
  }

  &__add {
    color: $accent;
    padding-top: 5px;
    padding-bottom: 5px;

    label {
      cursor: pointer;
    }

    &:hover {
      opacity: 0.6;
    }
  }
}
</style>
